// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ingress-egress-field {
  position: relative;
  min-height: 19px;
  width: 100%;
}

  .ingress-egress-field--editable {
    cursor: pointer;
  }

  .ingress-egress-field__text {
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    font-weight: 400;
    font-style: italic;
  }

  .ingress-egress-field__placeholder {
    color: rgb(118 118 118);
  }

  .ingress-egress-field__dd {
    position: absolute;
    z-index: 2;
    background: white;
    box-shadow: 0 1px 3px rgb(0 0 0 / 10%);
    cursor: default;
  }

  .ingress-egress-field__dd-pickers {
      display: flex;
    }

  .ingress-egress-field__dd-pickers > * {
        margin-left: 8px;
      }

  .ingress-egress-field__dd-pickers > *:first-child {
          margin-left: 0;
        }

  .ingress-egress-field__dd-pickers .rdtPicker {
        box-shadow: 0;
        border-bottom: 0;
      }

  .ingress-egress-field__dd-picker {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

  .ingress-egress-field__dd-label {
      padding: 4px 0;
      font-weight: 500;
    }

  .ingress-egress-field__dd-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 8px;
    }

  .ingress-egress-field__dd-error {
      margin-right: auto;
      color: var(--color-red-3);
    }
`, "",{"version":3,"sources":["webpack://./app/pages/DispatchPage/components/IngressEgressField/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AAmEb;;EAjEE;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,sCAAsC;IACtC,eAAe;EAyCjB;;EAvCE;MACE,aAAa;IAcf;;EAZE;QACE,gBAAgB;MAKlB;;EAHE;UACE,cAAc;QAChB;;EAGF;QACE,aAAa;QACb,gBAAgB;MAClB;;EAGF;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;IACrB;;EAEA;MACE,cAAc;MACd,gBAAgB;IAClB;;EAEA;MACE,aAAa;MACb,mBAAmB;MACnB,yBAAyB;MACzB,YAAY;IACd;;EAEA;MACE,kBAAkB;MAClB,yBAAyB;IAC3B","sourcesContent":[".ingress-egress-field {\n  position: relative;\n  min-height: 19px;\n  width: 100%;\n\n  &--editable {\n    cursor: pointer;\n  }\n\n  &__text {\n    display: inline-block;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 100%;\n    font-weight: 400;\n    font-style: italic;\n  }\n\n  &__placeholder {\n    color: rgb(118 118 118);\n  }\n\n  &__dd {\n    position: absolute;\n    z-index: 2;\n    background: white;\n    box-shadow: 0 1px 3px rgb(0 0 0 / 10%);\n    cursor: default;\n\n    &-pickers {\n      display: flex;\n\n      & > * {\n        margin-left: 8px;\n\n        &:first-child {\n          margin-left: 0;\n        }\n      }\n\n      & .rdtPicker {\n        box-shadow: 0;\n        border-bottom: 0;\n      }\n    }\n\n    &-picker {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n\n    &-label {\n      padding: 4px 0;\n      font-weight: 500;\n    }\n\n    &-footer {\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      padding: 8px;\n    }\n\n    &-error {\n      margin-right: auto;\n      color: var(--color-red-3);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
